/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Field_Passkey_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter a name for your passkey" |
*
* @param {Form_Field_Passkey_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_field_passkey_name_placeholder = /** @type {((inputs?: Form_Field_Passkey_Name_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Field_Passkey_Name_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gib einen Namen für deinen Passkey ein")
	return /** @type {LocalizedString} */ ("Enter a name for your passkey")
});